import { type ConfigurationStorageDataV1, isConfigurationStorageDataV1 } from './ConfigurationStorageDataV1'
import type { ConfigurationStorageDataV2 } from './ConfigurationStorageDataV2'

export const upgradeStorageData = (
  data: ConfigurationStorageDataV1 | ConfigurationStorageDataV2 | undefined,
): ConfigurationStorageDataV2 | undefined => {
  if (!data) {
    return undefined
  }

  if (isConfigurationStorageDataV1(data)) {
    return {
      ...data,
      version: '0.2.0',
      history: data.history?.map(({ family, fromVariant, wasUserSelectedVariant, toVariant, ...rest }) => ({
        ...rest,
        selections: [{ family, fromVariant, wasUserSelectedVariant, toVariant }],
      })),
    }
  }
  return data
}
